module.exports = __webpack_public_path__ + "static/media/default_custom.916c7851.png";